import __request__ from "routing/request";
export function activeQuery(page = 1, per_page = 500, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/query/active_query", null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function searchJobExecutionState(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/query/active_search_job_execution_state", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function resetActiveQuery(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/query/reset_active_query", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function searchJobExecutionStateByjob_id(job_id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake/query/search_job_execution_state/${job_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function singleMessageQuery(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/query/single_message", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
